export default __webpack_public_path__ + "static/media/IMG_3079_6_11zon.ceb91163.jpg";